"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var FormComponent_1;
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("../events");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `<form action="#" class="av-tooltip tooltip-label-bottom${x => x.horizontal ? ' form-horizontal' : ''}" style="--the-form-gap: ${x => x.gap}; --the-form-justify-content: ${x => x.justifyContent}; --the-form-align-items: ${x => x.alignItems};">              
    <slot></slot>
</form>`;
require("./styles/layout.scss");
const styles = T.css `form {
  align-items: var(--the-form-align-items, stretch);
  justify-content: var(--the-form-justify-content, flex-start);
}
form.form-horizontal {
  display: flex;
  flex-direction: row;
  gap: var(--the-form-gap, 0px);
}`;
const shadowOptions = { "mode": "open" };
let FormComponent = FormComponent_1 = class FormComponent extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.horizontal = false;
        this.gap = '0px';
        this.justifyContent = 'flex-start';
        this.alignItems = 'stretch';
        this.validateForm = () => {
            let passed = true;
            const slot = this.$('slot');
            const children = slot.assignedElements();
            const errors = [];
            for (const partBox of children) {
                if (['part-input', 'part-textarea', 'part-select', 'part-radio', 'part-tags'].includes(partBox.tagName.toLowerCase())) {
                    if (!this.validatePart(partBox, errors)) {
                        passed = false;
                    }
                }
                else {
                    partBox
                        .querySelectorAll('part-input, part-textarea, part-select, part-radio, part-tags')
                        .forEach((partElement) => {
                        if (!this.validatePart(partElement, errors)) {
                            passed = false;
                        }
                    });
                }
            }
            if (!passed) {
                this.popupService.alert(`
                    <div style="text-align: left;">
                        Form errors:
                        <ul style="text-align: left;">
                        ${errors.map(err => `<li>${err}</li>`).join('')}
                        </ul>
                    </div>`, true);
            }
            return passed;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        const _self = this;
        this.on(events_1.formEvents.submit, (event) => {
            const isTutorialForm = event.composedPath().some(target => target instanceof HTMLElement && target.tagName.toLowerCase() === 'tutorial-form');
            if (isTutorialForm) {
                console.log('[tutorial form] submit event received', { hasOnSubmit: !!this.onSubmit });
            }
            if (!this.onSubmit) {
                event.preventDefault();
                return;
            }
            const isValid = this.validateForm();
            if (isTutorialForm) {
                console.log('[tutorial form] component validation result', isValid);
            }
            if (!isValid) {
                return;
            }
            if (isTutorialForm) {
                console.log('[tutorial form] invoking onSubmit handler');
            }
            this.onSubmit(event);
        });
        // Handle Enter key to submit form (but not Shift+Enter)
        this.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
                const target = event.target;
                // Don't submit on Enter in textareas - let them handle line breaks normally
                if (target.tagName.toLowerCase() === 'textarea') {
                    return;
                }
                // Don't submit if we're in a multi-line input context
                if (target.hasAttribute('multiline')) {
                    return;
                }
                // Don't submit if we're focused on a tags input
                if (target.classList.contains('tags-input') || target.closest('part-tags')) {
                    return;
                }
                event.preventDefault();
                // Use getElement() method to get the actual DOM input element
                if (target && typeof target.getElement === 'function') {
                    const domElement = target.getElement();
                    if (domElement) {
                        // Trigger the natural change event on the actual DOM element
                        domElement.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                this.submitForm(event);
            }
        });
    }
    submitForm(event) {
        // Use the same pattern as the static sendSubmitEvent method
        const submitEvent = new CustomEvent(events_1.formEvents.submit, {
            detail: { submitted: true },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(submitEvent);
    }
    validatePart(partElement, errors) {
        let passed = true;
        if (partElement.getElement() && !partElement.getElement().checkValidity()) {
            passed = false;
            if (partElement.getElement().closest('.form-group')) {
                partElement.getElement().closest('.form-group').classList.add('is-invalid');
                const errorField = partElement.label || partElement.name;
                const errorMessage = partElement.getElement().validationMessage || 'Invalid input';
                const errorMessageCnt = `${errorField}: ${errorMessage}`;
                if (!errors.includes(errorMessageCnt)) {
                    errors.push(errorMessageCnt);
                }
            }
        }
        else {
            if (partElement.getElement() && partElement.getElement().closest('.form-group')) {
                partElement.getElement().closest('.form-group').classList.remove('is-invalid');
            }
        }
        return passed;
    }
    static sendSubmitEvent(x, c) {
        var _a;
        c.event.preventDefault();
        const submitEvent = new CustomEvent(events_1.formEvents.submit, {
            detail: { submitted: true },
            bubbles: true,
            composed: true
        });
        const form = (_a = x.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('the-form');
        if (!form) {
            console.error('[tutorial form] could not find form to dispatch submit event');
            return;
        }
        console.log('[tutorial form] dispatching submit event to form');
        form.dispatchEvent(submitEvent);
    }
    static listenForValuesChange(varName, after) {
        this.on(events_1.inputEvents.changed, (event) => {
            FormComponent_1.assignFormValues.bind(this)(varName, event);
            if (after) {
                after();
            }
        });
    }
    static assignFormValues(varName, event) {
        var _a;
        const key = event.detail.fieldName;
        const value = event.detail.value;
        // Check if form object exists
        if (!this[varName]) {
            console.warn(`Form object '${varName}' not found or not initialized`);
            return;
        }
        // Special handling for file uploads - always replace the entire value
        if (event.detail.formPartType === 'file-upload') {
            this[varName][key] = value;
        }
        else if ((_a = event.detail.element) === null || _a === void 0 ? void 0 : _a.multiple) {
            // For other multi-value inputs, push to array
            if (!Array.isArray(this[varName][key])) {
                this[varName][key] = [];
            }
            this[varName][key].push(value);
        }
        else {
            // For single-value inputs, directly assign
            this[varName][key] = value;
        }
        this[varName] = { ...this[varName] };
    }
    reset() {
        this.querySelectorAll('part-input, part-textarea, part-select, part-radio, part-switch, part-checkbox, part-tags')
            .forEach((partElement) => {
            partElement.reset();
        });
    }
};
exports.FormComponent = FormComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], FormComponent.prototype, "onSubmit", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], FormComponent.prototype, "horizontal", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FormComponent.prototype, "gap", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FormComponent.prototype, "justifyContent", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], FormComponent.prototype, "alignItems", void 0);
exports.FormComponent = FormComponent = FormComponent_1 = __decorate([
    (0, client_1.RWSView)('the-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], FormComponent);
FormComponent.defineComponent();
